export function shortcutButtons (fp) {
    const handleConfirmButton = () => {
        fp.config.confirmed.upperButtonTypes.date = fp.selectedDates
        fp.config.confirmed.upperButtonTypes.forEach((item, idx) => {
            item.active = fp.config.upperButtonTypes[idx].active
        })
        fp.config.shortcutButtons.events.handleConfirm(fp.config.confirmed.upperButtonTypes.date)
        fp.close()
    }
    const handleLimitMonthRangeToSixMonths = () => {
        if (fp.selectedDates.length === 1) {
            const startDate = fp.selectedDates[0]
            const sixMonthsBeforeStartDate = new Date(startDate.getFullYear(), startDate.getMonth() - 5)
            const sixMonthsAfterStartDate = new Date(startDate.getFullYear(), startDate.getMonth() + 5)
            fp.config.disable = [
                function (date) {
                    return (sixMonthsAfterStartDate > fp.config.minDate ? sixMonthsBeforeStartDate > date : false) || (sixMonthsAfterStartDate < fp.config.maxDate ? sixMonthsAfterStartDate < date : false)
                }
            ]
        } else {
            fp.config.disable = []
        }
    }
    const handleRemoveActiveLately = () => {
        if (fp.calendarContainer.querySelectorAll('.btn-lately-month')) {
            fp.calendarContainer.querySelectorAll('.btn-lately-month').forEach(el => el.classList.remove('active-lately'))
        }
    }
    const handleClickLatelyMonth = (btn, btnType) => {
        fp.config.disable = []
        if (btn.classList.contains('active-lately')) {
            fp.setDate([], true)
            btn.classList.remove('active-lately')
            btnType.active = false
            fp.calendarContainer.querySelector('.btn-confirm').classList.add('disable')
        } else {
            fp.setDate(btnType.date, true)
            handleRemoveActiveLately()
            btn.classList.add('active-lately')
            fp.config.upperButtonTypes.forEach(item => { item.active = false })
            btnType.active = true
        }
    }
    return {
        handleLimitMonthRangeToSixMonths,
        handleRemoveActiveLately,
        handleClickLatelyMonth,
        handleConfirmButton
    }
}
